export const initialState = {
  drawer: false
}


// WEBPACK FOOTER //
// ./src/interface/store/departments/drawer/selectors.js